import React from 'react';

import useVccSeasonDropdown from './UseVccSeasonDropdown';

import Dropdown from '@usas/ui-web/components/dropdowns/Dropdown';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const VccSeasonDropdown = ({ label, name, value, error, message, onChange }) => {
  const { vccSeasonState } = useVccSeasonDropdown();

  return vccSeasonState?.message
    ? <span className={global.LoadingMsg}>{vccSeasonState.message}</span>
    : (
      <Dropdown
        error={error}
        label={label}
        message={message}
        options={vccSeasonState.options}
        name={name}
        value={value}
        onChange={onChange}
        areValuesIntegers={true}
        isLoading={vccSeasonState?.isArrayLoading} />
    );
};

export default VccSeasonDropdown;